import { TReceipt } from "../../types/appointment";
import { OfflineAppointment } from "../../firestore/types";
import { paymentStatusMap } from "../constants";

export const getAptBillStatusForQueue = ({
  billValueSoFar,
  receipt,
}: {
  billValueSoFar: string;
  receipt: Partial<TReceipt>;
}): string => {
  if (
    billValueSoFar === paymentStatusMap.receipt_generated ||
    !receipt.payment_status ||
    paymentStatusMap[receipt?.payment_status] ===
      paymentStatusMap?.receipt_generated
  ) {
    return paymentStatusMap?.receipt_generated;
  }

  return paymentStatusMap[receipt.payment_status];
};

export const calculateAppointmentBillStatus = (
  appointment: OfflineAppointment
): string => {
  const initialStatus =
    appointment.payment_status === "success"
      ? paymentStatusMap.receipt_generated
      : "unbilled";

  return appointment.receipts.reduce(
    (billStatus, receipt) =>
      getAptBillStatusForQueue({
        billValueSoFar: billStatus,
        receipt,
      }),
    initialStatus
  );
};

export const normalizeReceiptPaymentStatus = <T extends { receipts: TReceipt[] }>(
  appointment: T
): T => {
  return {
    ...appointment,
    receipts: appointment.receipts.map((receipt) => ({
      ...receipt,
      payment_status: receipt?.payment_status ?? "success",
    })),
  };
};
